export const internalUrls: string[] = [
    'localhost.gm.com',
    'tprecm-ui-dev.apps.pcfepg2wi.gm.com',
    'tprecm-ui-qa.apps.pcfepg2wi.gm.com',
    'tprecm-ui-test.apps.pcfepg2wi.gm.com',
    'mesc.cpi.gm.com',
    'mesc.apps.pcf2mi.gm.com',
    'mesc.apps.pcfmi.gm.com',
    'mesc.apps.pcfwi.gm.com',
    'mesc-ui-dev.cp-epg2i.gm.com',
    'mesc-ui-qa.cp-epg2i.gm.com',
    'mesc-ui-test.cp-epg2i.gm.com',
    'mesc-green.apps.pcf2mi.gm.com',
    'mesc-green.apps.pcfmi.gm.com',
    'mesc-green.apps.pcfwi.gm.com',
    'mesc-blue.apps.pcf2mi.gm.com',
    'mesc-blue.apps.pcfmi.gm.com',
    'mesc-blue.apps.pcfwi.gm.com',
    'mesc-ui-ocf-dev.apps.pcfepgstg1mi.gm.com',
    'mesc-ui-ocf-qa.apps.pcfepgstg1mi.gm.com',
    'mesc-ui-ocf-test.apps.pcfepgstg1mi.gm.com',
    'mesc-ui.oc1i.gm.com',
    'mesc.oc1i.gm.com',
    'mesc.apps.oc1iw1.gm.com',
    'mesc.apps.oc1iw2.gm.com'
];
